<template>
  <form name="car-select-form" id="car-select-form">
    <div class="alert alert-danger hidden" id="car-select-form-msg">
      <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
      <strong>Note:</strong> All fields required!
    </div>

    <!-- Car select start -->
    <div class="styled-select-car">
      <select
          name="car-select "
          id="car-select"
          v-model="guid"
          :class="{ 'bg-danger text-danger': error.guid }"
      >
        <option value="0" selected="true">
          <span class="text-danger text-capitalize">{{l('selektuj_tip_auta')}}</span>
        </option>
        <option
            :value="vehicle.guid"
            v-for="(vehicle, index) in vehicles"
            :key="index"
        >{{ vehicle.full_name }}</option>
      </select>
    </div>
    <!-- Car select end -->

    <!-- Pick-up location start -->
    <div class="location">
      <div class="input-group pick-up" :class="{ 'bg-danger': error.pick_up }">
        <span class="input-group-addon text-capitalize">
          <span class="glyphicon glyphicon-map-marker"></span>
          {{l('pick_up')}}
        </span>
        <select
            name="pick-up-location"
            id="pick-up-location"
            v-model="pl"
            class="form-control autocomplete-location"
        >
          <option value="0" selected="true">
            <span class="text-danger text-capitalize">{{l('unesi_grad_aerodrom')}}</span>
          </option>
          <option
              :value="lokacija.name"
              v-for="(lokacija, index) in lokacije"
              :key="index"
          >{{ lokacija.name }}</option>
        </select>
      </div>
      <!-- Pick-up location end -->

      <br>

      <!-- Drop-off location start -->
      <div class="input-group drop-off" :class="{ 'bg-danger': error.drop_off }">
        <span class="input-group-addon text-capitalize">
          <span class="glyphicon glyphicon-map-marker"></span>
          {{l('drop_off')}}
        </span>
        <select name="drop-off-location" id="drop-off-location"
                class="form-control autocomplete-location"
                v-model="dl"
        >
          <option value="0" selected="true">
            <span class="text-danger text-capitalize">{{l('unesi_grad_aerodrom')}}</span>
          </option>
          <option
              :value="lokacija.name"
              v-for="(lokacija, index) in lokacije"
              :key="index"
          >{{ lokacija.name }}</option>
        </select>
      </div>
    </div>
    <!-- Drop-off location end -->

    <!-- Pick-up date/time start -->
    <div class="datetime pick-up">
      <div class="date pull-left">
        <div class="input-group" :class="{ 'bg-danger': error.start_date }">
          <span class="input-group-addon pixelfix text-capitalize">
            <span class="glyphicon glyphicon-calendar"></span>
            {{l('pick_up')}}
          </span>
          <input
              type="text"
              readonly="true"
              name="pick-up-date"
              id="pick-up-date"
              class="form-control datepicker"
              placeholder="mm/dd/yyyy"
          />
        </div>
      </div>
      <div class="time pull-right">
        <div class="styled-select-time">
          <select name="pick-up-time" id="pick-up-time">
            <option
                :value="d.h + ':' + d.m + ':' + d.d"
                v-for="(d, index) in dt"
                :key="index"
            >{{ d.h }} {{ d.m }} {{ d.d }}</option>
          </select>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <!-- Pick-up date/time end -->

    <!-- Drop-off date/time start -->
    <div class="datetime drop-off">
      <div class="date pull-left">
        <div class="input-group" :class="{ 'bg-danger': error.stop_date }">
          <span class="input-group-addon pixelfix text-capitalize">
            <span class="glyphicon glyphicon-calendar"></span>
            {{l('drop_off')}}
          </span>
          <input
              type="text"
              readonly="true"
              name="drop-off-date"
              id="drop-off-date"
              class="form-control datepicker"
              placeholder="mm/dd/yyyy"
          />
        </div>
      </div>
      <div class="time pull-right">
        <div class="styled-select-time">
          <select name="drop-off-time" id="drop-off-time">
            <option
                :value="d.h + ':' + d.m + ':' + d.d"
                v-for="(d, index) in dt"
                :key="index"
            >{{ d.h }} {{ d.m }} {{ d.d }}</option>
          </select>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <!-- Drop-off date/time end -->
    <input
        @click="submit()"
        class="submit"
        name="submit"
        :value="l('nastavi_sa_rezervacijom')"
        id="checkoutModalLabel"
        type="button"
    />
  </form>
</template>

<script>
import { Forma } from "../../site";
import site from "../../mixins/site";
export default {
  props: ["vehicles", "loc", "offices", "of", "langs", "lokacije"],
  mixins: [site],
  data() {
    return {
      error: {
        guid: 0,
        pl: 0,
        pick_up: false,
        start_date: false,
        stop_date: false
      },
      dt: [],
      locations: [],
      range: [],
      pl: "0",
      dl: "0",
      guid: "0"
    };
  },
  methods: {
    submit() {
      if (this.validate()) {
        Forma.$emit("refresh-form");
        $("#checkoutModal").modal();
      } else {
        $("#car-select-form-msg")
            .css("visibility", "visible")
            .hide()
            .fadeIn()
            .removeClass("hidden")
            .delay(2000)
            .fadeOut();
      }
    },
    resetError() {
      for (let i in this.error) {
        this.error[i] = false;
      }
    },
    validate() {
      let state = true;
      this.resetError();
      let start = document.getElementById("pick-up-location").value;
      let stop = document.getElementById("drop-off-location").value;

      Forma.$data.office_start_id = document.getElementById("pick-up-location").value;
      Forma.$data.start_date = document.getElementById("pick-up-date").value;
      Forma.$data.start_time = document.getElementById("pick-up-time").value;

      // Forma.$data.start_city = this.lokacije.find(o => o.value == start);
      // Forma.$data.stop_city = this.lokacije.find(o => o.value == stop);

      Forma.$data.office_stop_id = document.getElementById("drop-off-location").value;

      Forma.$data.stop_date = document.getElementById("drop-off-date").value;
      Forma.$data.stop_time = document.getElementById("drop-off-time").value;

      if (!this.validateSelect(this.guid)) {
        state = false;
      }

      let car = this.vehicles.find(o => {
        return o.guid == this.guid;
      });

      if (!car) {
        return (state = false);
      }
      Forma.$data.car = car;

      let lokacija = this.lokacije.find(o => {
        return o.name == this.pl;
      });
      let dlokacija = this.lokacije.find(o => {
        return o.name == this.dl;
      });
      if (!lokacija) {
        return (state = false);
      }
      if (!dlokacija) {
        return (state = false);
      }
      Forma.$data.lokacija = lokacija.name;
      Forma.$data.dlokacija = dlokacija.name;
      Forma.$data.lokacijaprice = lokacija.price;
      Forma.$data.dlokacijaprice = dlokacija.price;
      
      if (!this.validateLocation(Forma.$data.office_start_id, "pick_up")) {
        state = false;
      }

      if (!this.validateDate(Forma.$data.start_date, "start_date")) {
        state = false;
      }

      if (!this.validateDate(Forma.$data.stop_date, "stop_date")) {
        state = false;
      }

      if (
          this.calcDateTime(Forma.$data.start_date, Forma.$data.stop_date) < 0
      ) {
        state = false;
      }

      let days = this.calcDateTime(
          Forma.$data.start_date,
          Forma.$data.stop_date
      );

      Forma.$data.price = "Po dogovoru";
      for (let i = 0; i < car.prices.length; i++) {
        if (this.inRange(car.prices[i].start, car.prices[i].stop, days, start, lokacija)) {
          let price = car.prices[i].selected * days + lokacija.price + dlokacija.price;
          let baseprice = car.prices[i].selected * days;
          Forma.$data.price = price.toFixed(2);
          Forma.$data.baseprice = baseprice.toFixed(2);
        }
      }
      return state;
    }
  },
  mounted() {
    let self = this;
        Forma.$on("clear-data", r => {
      self.guid = 0;
      document.getElementById("pick-up-location").value = "";
      document.getElementById("drop-off-location").value = "";
    });
    Forma.$data.office_start_id = document.getElementById("pick-up-location").value;
    this.locations = this.lokacije;
    this.makeDateTime();

    $(".autocomplete-location").autocomplete({
      lookup: self.locations
    });

    var checkin = $("#pick-up-date")
        .datepicker({
          onRender: function(date) {
            return date.valueOf() < now.valueOf() ? "disabled" : "";
          }
        })
        .on("changeDate", function(ev) {
          if (ev.date.valueOf() > checkout.date.valueOf()) {
            var newDate = new Date(ev.date);
            newDate.setDate(newDate.getDate() + 1);
            checkout.setValue(newDate);
          }
          checkin.hide();
          $("#drop-off-date")[0].focus();
        })
        .data("datepicker");
    var checkout = $("#drop-off-date")
        .datepicker({
          onRender: function(date) {
            return date.valueOf() <= checkin.date.valueOf() ? "disabled" : "";
          }
        })
        .on("changeDate", function(ev) {
          checkout.hide();
        })
        .data("datepicker");
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// resources/assets/js/components/site/TopForm.vue